import React, { useState, useEffect, useRef, useCallback } from 'react';

// Calendar data for awareness days
const awarenessEvents = [
  {
    id: 1,
    title: "Giornata mondiale delle Malattie Rare",
    date: new Date(new Date().getFullYear(), 1, 29), // Feb 29
    description: "Una giornata dedicata alla sensibilizzazione sulle malattie rare che colpiscono milioni di persone in tutto il mondo.",
    color: "bg-blue-500",
    type: "day"
  },
  {
    id: 2,
    title: "Giornata mondiale della Depressione",
    date: new Date(new Date().getFullYear(), 3, 7), // Apr 7
    description: "Una giornata per aumentare la consapevolezza sulla depressione, una condizione che colpisce milioni di persone globalmente.",
    color: "bg-purple-500",
    type: "day"
  },
  {
    id: 3,
    title: "Giornata mondiale dell'Emofilia",
    date: new Date(new Date().getFullYear(), 3, 17), // Apr 17
    description: "Una giornata dedicata alla sensibilizzazione sull'emofilia, altri deficit congeniti dei fattori della coagulazione e la Malattia di Von Willebrand.",
    color: "bg-red-500",
    type: "day"
  },
  {
    id: 4,
    title: "Giornata mondiale della Talassemia",
    date: new Date(new Date().getFullYear(), 4, 8), // May 8
    description: "Una giornata per aumentare la consapevolezza sulla talassemia, una malattia genetica che colpisce la produzione di emoglobina.",
    color: "bg-orange-500",
    type: "day"
  },
  {
    id: 5,
    title: "Settimana mondiale dell'Emocromatosi",
    date: new Date(new Date().getFullYear(), 5, 1), // Jun 1-7
    endDate: new Date(new Date().getFullYear(), 5, 7),
    description: "Una settimana dedicata all'emocromatosi, un disturbo che causa l'accumulo eccessivo di ferro nell'organismo.",
    color: "bg-amber-600",
    type: "week"
  },
  {
    id: 6,
    title: "Giornata mondiale dell'Anemia di Fanconi",
    date: new Date(new Date().getFullYear(), 5, 14), // Jun 14
    description: "Una giornata dedicata alla sensibilizzazione sull'Anemia di Fanconi, una rara malattia genetica che colpisce il midollo osseo.",
    color: "bg-pink-500",
    type: "day"
  },
  {
    id: 7,
    title: "Giornata mondiale dell'Anemia a cellule falciformi",
    date: new Date(new Date().getFullYear(), 5, 19), // Jun 19
    description: "Una giornata dedicata alla drepanocitosi (anemia a cellule falciformi), una malattia genetica che colpisce i globuli rossi.",
    color: "bg-red-600",
    type: "day"
  },
  {
    id: 8,
    title: "Giornata mondiale della Porpora trombotica trombocitopenica",
    date: new Date(new Date().getFullYear(), 6, 5), // Jul 5
    description: "Una giornata dedicata alla sensibilizzazione sulla Porpora trombotica trombocitopenica, un disturbo raro del sangue.",
    color: "bg-indigo-500",
    type: "day"
  },
  {
    id: 9,
    title: "Giornata mondiale della Malattia di Castleman",
    date: new Date(new Date().getFullYear(), 6, 23), // Jul 23
    description: "Una giornata dedicata alla Malattia di Castleman, un raro disturbo linfoproliferativo che può colpire singoli o multipli linfonodi.",
    color: "bg-green-600",
    type: "day"
  },
  {
    id: 10,
    title: "Giornata mondiale della Donazione di midollo osseo",
    date: new Date(new Date().getFullYear(), 8, 21), // Sep 21
    description: "Una giornata per sensibilizzare sull'importanza della donazione di midollo osseo, cruciale per molti pazienti con malattie del sangue.",
    color: "bg-teal-500",
    type: "day"
  },
  {
    id: 11,
    title: "Settimana mondiale della Piastrinopenia immune",
    date: new Date(new Date().getFullYear(), 8, 23), // Sep 23-27
    endDate: new Date(new Date().getFullYear(), 8, 27),
    description: "Una settimana dedicata alla piastrinopenia immune, un disturbo caratterizzato da un basso numero di piastrine nel sangue.",
    color: "bg-cyan-600",
    type: "week"
  },
  {
    id: 12,
    title: "Giornata mondiale della Malattia di Gaucher",
    date: new Date(new Date().getFullYear(), 9, 1), // Oct 1
    description: "Una giornata dedicata alla Malattia di Gaucher, un disturbo metabolico ereditario raro.",
    color: "bg-emerald-500",
    type: "day"
  },
  {
    id: 13,
    title: "Giornata mondiale della Emoglobinuria parossistica notturna",
    date: new Date(new Date().getFullYear(), 9, 12), // Oct 12
    description: "Una giornata dedicata all'Emoglobinuria parossistica notturna, una rara malattia acquisita del sangue.",
    color: "bg-violet-600",
    type: "day"
  },
  {
    id: 14,
    title: "Giornata mondiale della Trombosi",
    date: new Date(new Date().getFullYear(), 9, 13), // Oct 13
    description: "Una giornata dedicata alla sensibilizzazione sulla trombosi e sui disordini ereditari trombofilici.",
    color: "bg-rose-600",
    type: "day"
  },
  {
    id: 15,
    title: "Giornata mondiale della Mastocitosi",
    date: new Date(new Date().getFullYear(), 9, 20), // Oct 20
    description: "Una giornata dedicata alla mastocitosi e ai disordini mastocitari, condizioni rare che comportano un accumulo anomalo di mastociti.",
    color: "bg-fuchsia-500",
    type: "day"
  },
  {
    id: 16,
    title: "Giornata mondiale delle Sindromi mieloidisplastiche",
    date: new Date(new Date().getFullYear(), 9, 25), // Oct 25
    description: "Una giornata dedicata alle sindromi mielodisplastiche, un gruppo di disturbi che colpiscono la produzione delle cellule del sangue.",
    color: "bg-sky-600",
    type: "day"
  },
  {
    id: 17,
    title: "Giornata mondiale dell'Amiloidosi",
    date: new Date(new Date().getFullYear(), 9, 26), // Oct 26
    description: "Una giornata dedicata all'amiloidosi primaria e familiare, un gruppo di malattie rare caratterizzate dall'accumulo di proteine anomale negli organi.",
    color: "bg-lime-600",
    type: "day"
  }
];

const monthNames = [
  "Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno",
  "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"
];

const dayNames = ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"];

// Past events data
const pastEvents = [
  {
    id: 1,
    title: "Una giornata per…COSTRUIRE INSIEME",
    date: "18 novembre 2023",
    time: "10:00 - 19:00",
    location: "Albergo Etico",
    description: "Il 18 novembre 2023 si è svolto il secondo incontro dell'Associazione presso l' Albergo Etico, che ci ha, anche questa volta, entusiasticamente ospitato!\n\nÈ stata una giornata all'insegna della condivisone, della generosità e del buon umore.\nOltre ad un mercatino, reso prezioso dai quadri di Angelo Addessi e Gigliana Pelliccia, e dalle fotografie di Antonella Stelitano, è stato possibile assaporare momenti di relax in uno spazio dedicato .\n\nLa Presidente, dr.ssa Fiorina Giona, ha sottolineato l'importanza di un'alleanza che aiuti a costruire un percorso finalizzato non solo ad un'assistenza diagnostico-terapeutica adeguata, ma anche al benessere, non solo fisico, dei pazienti con malattie rare ematologiche e dei loro parenti.\nLa psicologa, dr.ssa Flora Gigli, prendendo spunto dal suo libro 'La cura del paziente oncoematologico', ha condiviso delle riflessioni sulle emozioni e sui bisogni che i pazienti si trovano ad affrontare nelle diverse fasi del percorso di cura.\nPaolo D'Isanto e Pascal La Delfa, meglio noti ai nostri pazienti come Dottor Ragù e Dottor Suppergiù, sono stati la sorpresa della giornata.\n\nNel pomeriggio, sono state proposte due forme di meditazione utili al rilassamento.\nLa Maestra Stefania Grappasonni ha proposto dolci esercizi per il corpo e la mente di Tai Chi Chuan e Qi Gong.\nL'Insegnante Linda Fidanzia ha condiviso un'esperienza di Mindfulness, utile a calmare la mente.\n\nA fine giornata, la Dr.ssa Loredana Battista ha regalato una ventata di leggerezza con l'angolo delle stelle.\nLa presenza numerosa e la partecipazione attiva di pazienti, dei loro parenti, e di amici ci ha scaldato il cuore e incoraggiato a proseguire nel nostro cammino.\n\nArrivederci nella primavera 2024!",
    color: "bg-accent",
  },
  {
    id: 2,
    title: "La prima raccolta fondi dell'Associazione",
    date: "19 giugno 2023",
    time: "19:30 - 22:30",
    location: "Albergo Etico",
    description: "Il 19 di giugno si e' svolto un festoso incontro per la Ripartenza dell' Associazione presso l' Albergo Etico, che ci ha entusiasticamente ospitato! E' stata una serata emozionante con la presenza di molti pazienti (bambini e adulti), ex pazienti con figli e familiari.\n\nLa presenza di numerosi medici dell'Ematologia che da anni seguono questi pazienti ha contribuito a trasformare l'evento in una festa senza barriere e senza distinzione di ruoli, tra volontari, membri dell'Associazione, pazienti e medici.\nIl filo conduttore della serata e' stato il concetto di ripartenza!\n\nLa Presidente Dr.ssa Giona Fiorina ha rimarcato come sia importante per l'Associazione ripartire dopo il periodo del COVID con nuovo slancio e forza per fare sì che nessuno resti indietro quando si tratta di affrontare malattie rare ematologiche, di qualsiasi tipo! Emozionanti gli interventi di pazienti e familiari nel raccontare la loro sfida contro la malattia e il successivo ritorno vita normale!\n\nUn grazie al professore Maurizio Martelli, Direttore dell' Ematologia, per il sua saluto!",
    color: "bg-primary",
  }
];

const Eventi = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [calendar, setCalendar] = useState([]);
  const [lastFocusedElement, setLastFocusedElement] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [selectedPastEvent, setSelectedPastEvent] = useState(null);
  const [isPastEventModalOpen, setIsPastEventModalOpen] = useState(false);
  
  // Refs for accessibility and focus management
  const modalRef = useRef(null);
  const closeButtonRef = useRef(null);
  const calendarCellsRef = useRef({});

  useEffect(() => {
    generateCalendarMonths();
  }, [currentDate]);

  // Add tooltip position adjustment
  useEffect(() => {
    // Function to adjust tooltip positions
    const adjustTooltipPositions = () => {
      const tooltips = document.querySelectorAll('.tooltip-container');
      
      tooltips.forEach(tooltip => {
        // Get tooltip dimensions
        const rect = tooltip.getBoundingClientRect();
        const parentRect = tooltip.closest('.group').getBoundingClientRect();
        
        // Check if tooltip is going off-screen
        const isOffScreenRight = rect.right > window.innerWidth;
        const isOffScreenLeft = rect.left < 0;
        const isOffScreenTop = rect.top < 0;
        
        // Reset styles
        tooltip.style.bottom = '120%';
        tooltip.style.top = 'auto';
        tooltip.style.left = '50%';
        tooltip.style.transform = 'translateX(-50%)';
        
        // Adjust position if needed
        if (isOffScreenLeft) {
          tooltip.style.left = '0';
          tooltip.style.transform = 'translateX(0)';
        } else if (isOffScreenRight) {
          tooltip.style.left = 'auto';
          tooltip.style.right = '0';
          tooltip.style.transform = 'translateX(0)';
        }
        
        if (isOffScreenTop) {
          tooltip.style.bottom = 'auto';
          tooltip.style.top = '120%';
          
          // Move the arrow to the top
          const arrow = tooltip.querySelector('div > div:last-child');
          if (arrow) {
            arrow.classList.remove('top-full', 'border-t-gray-800');
            arrow.classList.add('bottom-full', 'border-b-gray-800');
          }
        }
      });
    };

    // Set up a mutation observer to detect when new tooltips appear
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && 
            mutation.attributeName === 'class' && 
            mutation.target.classList.contains('opacity-100')) {
          adjustTooltipPositions();
        }
      });
    });
    
    // Start observing changes
    const tooltipContainers = document.querySelectorAll('.tooltip-container');
    tooltipContainers.forEach(container => {
      observer.observe(container, { attributes: true });
    });
    
    // Also adjust on window resize
    window.addEventListener('resize', adjustTooltipPositions);
    
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', adjustTooltipPositions);
    };
  }, [calendar]);
  
  // Scroll to top button visibility
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  
  // Function to scroll to top
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  // Generate calendar months for the entire year
  const generateCalendarMonths = () => {
    const months = [];
    const year = currentDate.getFullYear();
    
    for (let month = 0; month < 12; month++) {
      const firstDay = new Date(year, month, 1);
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      
      // Calculate days from previous month to fill first week
      const dayOfWeek = firstDay.getDay();
      const prevMonthDays = [];
      for (let i = 0; i < dayOfWeek; i++) {
        const day = new Date(year, month, -i);
        prevMonthDays.unshift(day);
      }
      
      // Current month days
      const monthDays = [];
      for (let day = 1; day <= daysInMonth; day++) {
        monthDays.push(new Date(year, month, day));
      }
      
      // Calculate days from next month to complete last week
      const totalDaysDisplayed = prevMonthDays.length + monthDays.length;
      const nextMonthDays = [];
      for (let i = 1; i <= (42 - totalDaysDisplayed); i++) {
        nextMonthDays.push(new Date(year, month + 1, i));
      }
      
      months.push({
        name: monthNames[month],
        days: [...prevMonthDays, ...monthDays, ...nextMonthDays]
      });
    }
    
    setCalendar(months);
  };

  // Check if a specific date has events
  const getEventsForDate = (date) => {
    return awarenessEvents.filter((event) => {
      if (event.type === 'day') {
        return date.getDate() === event.date.getDate() && 
               date.getMonth() === event.date.getMonth();
      } else if (event.type === 'week') {
        // For week events
        const eventStartTime = event.date.getTime();
        const eventEndTime = event.endDate.getTime();
        const dateTime = date.getTime();
        return dateTime >= eventStartTime && dateTime <= eventEndTime;
      }
      return false;
    });
  };

  // Open modal with event details
  const openEventModal = (event, sourceElement = null) => {
    if (sourceElement) {
      setLastFocusedElement(sourceElement);
    }
    setSelectedEvent(event);
    setIsModalOpen(true);
  };

  // Open modal with past event details
  const openPastEventModal = (event, sourceElement = null) => {
    if (sourceElement) {
      setLastFocusedElement(sourceElement);
    }
    setSelectedPastEvent(event);
    setIsPastEventModalOpen(true);
  };
  
  // Close modal
  const closeModal = () => {
    setIsModalOpen(false);
    setTimeout(() => setSelectedEvent(null), 300);
    
    // Return focus to the element that opened the modal
    if (lastFocusedElement) {
      setTimeout(() => {
        lastFocusedElement.focus();
      }, 50);
    }
  };
  
  // Close past event modal
  const closePastEventModal = () => {
    setIsPastEventModalOpen(false);
    setTimeout(() => setSelectedPastEvent(null), 300);
    
    // Return focus to the element that opened the modal
    if (lastFocusedElement) {
      setTimeout(() => {
        lastFocusedElement.focus();
      }, 50);
    }
  };

  // Handle keyboard interactions for the modal
  const handleModalKeyDown = (e) => {
    if (e.key === 'Escape') {
      closeModal();
    }
  };

  // Handle keyboard interactions for the past event modal
  const handlePastEventModalKeyDown = (e) => {
    if (e.key === 'Escape') {
      closePastEventModal();
    }
  };

  // Focus trapping for the modal
  useEffect(() => {
    if (isModalOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isModalOpen]);
  
  // Focus trapping for the past event modal
  useEffect(() => {
    if (isPastEventModalOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [isPastEventModalOpen]);

  // Handle keyboard navigation for calendar cells
  const handleCalendarKeyDown = useCallback((e, day, monthIndex, dayIndex, events) => {
    // Handle Enter or Space to open modal
    if ((e.key === 'Enter' || e.key === ' ') && events.length > 0) {
      e.preventDefault();
      openEventModal(events[0], e.target);
      return;
    }

    // Arrow key navigation
    const handleArrowNavigation = (nextMonthIndex, nextDayIndex) => {
      e.preventDefault();
      const nextCell = calendarCellsRef.current[`${nextMonthIndex}-${nextDayIndex}`];
      if (nextCell) {
        nextCell.focus();
      }
    };

    switch (e.key) {
      case 'ArrowRight':
        handleArrowNavigation(monthIndex, dayIndex + 1);
        break;
      case 'ArrowLeft':
        handleArrowNavigation(monthIndex, dayIndex - 1);
        break;
      case 'ArrowUp':
        handleArrowNavigation(monthIndex, dayIndex - 7);
        break;
      case 'ArrowDown':
        handleArrowNavigation(monthIndex, dayIndex + 7);
        break;
      default:
        break;
    }
  }, [openEventModal]);

  // Format date for display
  const formatDate = (date) => {
    return `${date.getDate()} ${monthNames[date.getMonth()]}`;
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-primary to-primary/80">
        <div className="container mx-auto px-4 py-16 md:py-24">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Eventi</h1>
            <p className="text-xl text-white md:w-3/4 mx-auto">
            Scopri le giornate dedicate alla sensibilizzazione sulle malattie rare, eventi annuali che si ripetono ogni anno per aumentare la consapevolezza e il supporto.
            </p>
          </div>
        </div>
      </div>

      {/* Prossimi Eventi Section */}
      <div className="container mx-auto px-4 py-8">
          <div className="bg-gradient-to-b from-white to-primary/5 rounded-lg shadow-md p-6 mb-8 border border-primary/10">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 mr-2 text-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Prossimi Eventi
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              <span className="font-semibold block mb-2">Calendario delle Giornate di Sensibilizzazione</span>
              Scopri le giornate dedicate alla sensibilizzazione sulle malattie rare, eventi annuali che si ripetono ogni anno per aumentare la consapevolezza e il supporto.
            </p>
            <div className="flex justify-center py-10">
              <p className="text-lg text-indigo-600 italic animate-pulse">Contenuto in arrivo...</p>
            </div>
          </div>
        </div>
        
        {/* Eventi Passati Section */}
        <div className="container mx-auto px-4 py-8">
          <div className="bg-gradient-to-b from-white to-accent/5 rounded-lg shadow-md p-6 mb-8 border border-accent/10">
            <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 mr-2 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Eventi Passati
            </h2>
            <p className="text-gray-700 mb-6 leading-relaxed">
              <span className="font-semibold block mb-2">Calendario delle Giornate di Sensibilizzazione</span>
              Scopri le giornate dedicate alla sensibilizzazione sulle malattie rare, eventi annuali che si ripetono ogni anno per aumentare la consapevolezza e il supporto.
            </p>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
              {pastEvents.map((event) => (
                <div 
                  key={event.id} 
                  className="bg-white rounded-lg shadow-md overflow-hidden border border-accent/10 hover:shadow-lg transition-all duration-300 transform hover:scale-102"
                >
                  <div className={`${event.color} text-white p-4`}>
                    <h3 className="text-xl font-bold">{event.title}</h3>
                    <p className="text-sm mt-2 opacity-90 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      {event.date}
                    </p>
                    <p className="text-sm mt-1 opacity-90 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      {event.time}
                    </p>
                    <p className="text-sm mt-1 opacity-90 flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      {event.location}
                    </p>
                  </div>
                  <div className="p-4">
                    <div className="text-sm text-gray-700 mb-4 line-clamp-3">
                      {event.description.split('\n')[0]}
                    </div>
                    <button 
                      className="mt-2 inline-flex items-center px-4 py-2 bg-accent text-white text-sm font-medium rounded-md hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-accent transition-colors duration-300"
                      onClick={(e) => {
                        e.preventDefault();
                        openPastEventModal(event, e.currentTarget);
                      }}
                    >
                      Leggi tutto
                      <svg xmlns="http://www.w3.org/2000/svg" className="ml-2 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      {/* Calendar Section */}
      <div className="container mx-auto px-4 py-8">
        <div className="bg-gradient-to-r from-primary/5 to-accent/5 rounded-lg shadow-md p-6 mb-8 border border-primary/10">
          <h2 className="text-2xl font-bold text-gray-800 mb-4 flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-7 w-7 mr-2 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
            </svg>
            Calendario Annuale
          </h2>
          <p className="text-gray-700 mb-6 leading-relaxed">
            Questo calendario presenta tutte le giornate mondiali dedicate alla sensibilizzazione sulle malattie rare. 
            Queste ricorrenze si ripetono ogni anno alle stesse date e sono un'occasione importante per informare, 
            sensibilizzare e sostenere i pazienti, le famiglie e gli operatori sanitari coinvolti.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {calendar.map((month, monthIndex) => (
            // Only show months with events
            awarenessEvents.some(event => event.date.getMonth() === monthIndex) && (
              <div 
                key={month.name} 
                className="bg-white rounded-lg shadow-md overflow-hidden transform transition-all duration-500 hover:shadow-lg animate-fadeIn" 
                id={`month-${monthIndex}`}
                style={{ animationDelay: `${monthIndex * 100}ms` }}
              >
                <div className="bg-gradient-to-r from-primary to-primary
 text-white px-4 py-3">
                  <h3 className="text-xl font-semibold">{month.name}</h3>
                </div>
                <div className="p-4">
                  {/* Days of week headers */}
                  <div className="grid grid-cols-7 gap-1 mb-2">
                    {dayNames.map(day => (
                      <div key={day} className="text-center text-sm font-medium text-gray-500" role="columnheader" aria-label={day}>
                        {day}
                      </div>
                    ))}
                  </div>
                  
                  {/* Calendar days */}
                  <div className="grid grid-cols-7 gap-1" role="grid" aria-label={`Calendario di ${month.name}`}>
                    {month.days.map((day, index) => {
                      const isCurrentMonth = day.getMonth() === monthIndex;
                      const events = getEventsForDate(day);
                      const hasEvents = events.length > 0;
                      
                      return (
                        <div 
                          key={index}
                          ref={el => calendarCellsRef.current[`${monthIndex}-${index}`] = el}
                          className={`
                            p-2 min-h-[40px] text-center rounded-md 
                            ${isCurrentMonth ? 'text-gray-800' : 'text-gray-400'} 
                            ${hasEvents ? 'cursor-pointer relative shadow-sm focus:ring-2 focus:ring-primary focus:outline-none' : ''}\
                            ${hasEvents ? 'before:absolute before:inset-0 before:rounded-md before:bg-gray-100 before:opacity-0 hover:before:opacity-90 before:transition-opacity before:duration-300 before:ease-in-out' : ''}
                            ${hasEvents ? 'after:absolute after:inset-0 after:rounded-md after:shadow-md after:opacity-0 hover:after:opacity-100 after:transition-opacity after:duration-300 after:ease-in-out' : ''}
                            ${hasEvents ? 'hover:scale-105 transform transition-transform duration-300 ease-in-out' : ''}
                            relative
                          `}
                          role="gridcell"
                          aria-label={`${day.getDate()} ${monthNames[day.getMonth()]}, ${hasEvents ? events.length + ' eventi' : 'nessun evento'}`}
                          tabIndex={hasEvents ? 0 : -1}
                          onClick={(e) => {
                            if (hasEvents && events.length === 1) {
                              openEventModal(events[0], e.currentTarget);
                            } else if (hasEvents && events.length > 1) {
                              // If multiple events, show first one
                              openEventModal(events[0], e.currentTarget);
                            }
                          }}
                          onKeyDown={(e) => hasEvents && handleCalendarKeyDown(e, day, monthIndex, index, events)}
                        >
                          <span className="text-sm">{day.getDate()}</span>
                          
                          {/* Event indicators */}
                          {hasEvents && (
                            <div className="mt-1 flex flex-wrap justify-center gap-1">
                              {events.map((event, eventIndex) => (
                                <span 
                                  key={eventIndex} 
                                  className={`${event.color} w-2 h-2 rounded-full inline-block transform transition-all duration-300 hover:scale-150`}
                                  aria-hidden="true"
                                />
                              ))}
                            </div>
                          )}
                          
                          {/* Tooltip for hover */}
                          {hasEvents && (
                            <div className="absolute inset-0 rounded-md group">
                              <div 
                                className="tooltip-container opacity-0 group-hover:opacity-100 group-focus-within:opacity-100 transition-all duration-300 transform group-hover:translate-y-0 translate-y-1 absolute z-50"
                                style={{
                                  bottom: '120%',
                                  left: '50%',
                                  transform: 'translateX(-50%)',
                                  maxWidth: '250px',
                                  width: 'max-content'
                                }}
                              >
                                  <div className="px-3 py-2 bg-gray-800 text-white text-xs rounded-md shadow-lg backdrop-blur">
                                  <div className="px-3 py-2 bg-gray-800 text-white text-xs rounded-md shadow-lg">
                                    {events.map((event, eventIndex) => (
                                      <div key={eventIndex} className="whitespace-normal break-words">
                                        {event.title}
                                        {eventIndex < events.length - 1 && <hr className="my-1 border-gray-600" />}
                                      </div>
                                    ))}
                                  </div>
                                  <div className="absolute top-full left-1/2 transform -translate-x-1/2 border-4 border-transparent border-t-gray-800"></div>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                    )})}
                  </div>
                </div>
              </div>
            )
          ))}
        </div>
        
        
        
        {/* Event Detail Modal */}
        {isModalOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn"
            onClick={(e) => e.target === e.currentTarget && closeModal()}
            onKeyDown={handleModalKeyDown}
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-title"
            ref={modalRef}
          >
            <div 
              className="bg-white rounded-xl shadow-2xl w-full max-w-md mx-4 overflow-hidden animate-scaleIn border border-gray-200"
              onClick={(e) => e.stopPropagation()}
            >
              {selectedEvent && (
                <>
                  <div className={`${selectedEvent.color} px-6 py-5 text-white relative`}>
                    <button
                      ref={closeButtonRef}
                      onClick={closeModal}
                      className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                      aria-label="Chiudi modal"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <h3 className="text-2xl font-bold" id="modal-title">{selectedEvent.title}</h3>
                    <div className="flex items-center mt-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <p className="text-sm opacity-90">
                        {selectedEvent.type === 'day' 
                          ? formatDate(selectedEvent.date)
                          : `${formatDate(selectedEvent.date)} - ${formatDate(selectedEvent.endDate)}`
                        }
                      </p>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="bg-gray-50 p-4 rounded-lg mb-6 border-l-4 border-gray-300">
                      <p className="text-gray-700 leading-relaxed">
                        {selectedEvent.description}
                      </p>
                    </div>
                    <div className="border-t pt-4 mt-4 flex justify-end">
                      <button
                        onClick={closeModal}
                        className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                        aria-label="Chiudi modal"
                      >
                        Chiudi
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        
        {/* Past Event Detail Modal */}
        {isPastEventModalOpen && (
          <div 
            className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50 animate-fadeIn p-4 md:p-6"
            onClick={(e) => e.target === e.currentTarget && closePastEventModal()}
            onKeyDown={handlePastEventModalKeyDown}
            role="dialog"
            aria-modal="true"
            aria-labelledby="past-modal-title"
            ref={modalRef}
          >
            <div 
              className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-scaleIn border border-gray-200 flex flex-col"
              onClick={(e) => e.stopPropagation()}
            >
              {selectedPastEvent && (
                <>
                  <div className={`${selectedPastEvent.color} px-6 py-5 text-white relative sticky top-0 z-10`}>
                    <button
                      ref={closeButtonRef}
                      onClick={closePastEventModal}
                      className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white bg-opacity-20 text-white rounded-full hover:bg-opacity-30 transition-all duration-300 transform hover:rotate-90 focus:outline-none focus:ring-2 focus:ring-white"
                      aria-label="Chiudi modal"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </button>
                    <h3 className="text-2xl font-bold" id="past-modal-title">{selectedPastEvent.title}</h3>
                    <div className="flex items-center mt-2">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedPastEvent.date}</p>
                    </div>
                    <div className="flex items-center mt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedPastEvent.time}</p>
                    </div>
                    <div className="flex items-center mt-1">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                      </svg>
                      <p className="text-sm opacity-90">{selectedPastEvent.location}</p>
                    </div>
                  </div>
                  <div className="p-6 pb-16 max-h-[70vh] overflow-y-auto">
                    <div className="bg-gray-50 p-5 rounded-lg mb-6 border-l-4 border-gray-300">
                      <h4 className="font-semibold text-gray-800 mb-3">Info</h4>
                      <div className="text-gray-700 leading-relaxed whitespace-pre-line text-base">
                        {selectedPastEvent.description}
                      </div>
                    </div>
                  </div>
                  <div className="p-3 flex justify-end shadow-lg border-t border-gray-200 sticky bottom-0 z-10 bg-transparent backdrop-blur-sm">
                    <button
                      onClick={closePastEventModal}
                      className="px-5 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-800 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 shadow-sm"
                      aria-label="Chiudi modal"
                    >
                      Chiudi
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        
        {/* Scroll to top button */}
        {showScrollTop && (
          <button 
            onClick={scrollToTop}
            className="fixed right-6 bottom-6 p-3 rounded-full bg-accent text-white shadow-lg hover:bg-accent/90 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-opacity-50 transform transition-all duration-300 hover:scale-110 z-40 animate-fadeIn"
            aria-label="Torna all'inizio della pagina"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 11l7-7 7 7M5 19l7-7 7 7" />
            </svg>
          </button>
        )}
      </div>
    </div>
  );
};

// Define animations in CSS
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes scaleIn {
    from { transform: scale(0.95); opacity: 0; }
    to { transform: scale(1); opacity: 1; }
  }
  
  .animate-fadeIn {
    animation: fadeIn 0.3s ease-in-out forwards;
  }
  
  .animate-scaleIn {
    animation: scaleIn 0.3s ease-out forwards;
  }
`;
document.head.appendChild(style);

export default Eventi;
